import { generatorControlSurfaceClassName } from './common'
import QRCode from 'react-qr-code'
import { useContextPanels } from '../../contexts/panelsContext'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { UIElement } from '../../types/UIElements'
import { useContextMotifGenerator } from '../../contexts/motifGeneratorContext'
import { cn } from '../../utils/cn'

const QRGenerator = () => {
  const { panelState, isPanelOpen, closeAll } = useContextPanels()
  const { setExportInvoked, setStartExport, qrCodeLink, setQrCodeLink } = useContextMotifGenerator()
  const { t } = useTranslation()
  // the export opens the modal once the image is uploaded and the link is ready
  const isOpen = isPanelOpen(UIElement.QRMODAL) && !!qrCodeLink

  useEffect(() => {
    if (isPanelOpen(UIElement.QRMODAL)) {
      // Don't set loading here - it's already managed by the export process
      setExportInvoked(true)
    } else if (qrCodeLink) {
      setExportInvoked(false)
      setStartExport(false)
      setQrCodeLink('')
    }
  }, [panelState])

  return (
    <>
      <div
        className={cn('fixed left-0 top-0 z-10 h-screen w-screen', {
          block: isOpen,
          hidden: !isOpen,
        })}
        onClick={() => closeAll()}
      />
      <div
        className={cn(
          generatorControlSurfaceClassName,
          'fixed right-0 top-[calc(50%-230px)] z-[11] flex h-[335px] w-[280px] flex-col items-center justify-evenly [transition:0.2s_ease-out] lg:h-[380px] lg:w-[330px] xl:top-[calc(50%-220px)] xl:h-[450px] xl:w-[415px]',
          { '[transform:translateX(0px)]': isOpen, '[transform:translateX(100%)]': !isOpen },
        )}
      >
        <p className="w-[180px] text-[18px] leading-[28px] tracking-[0.92px] text-black49 lg:w-[250px] lg:text-[20px] lg:leading-[42px] xl:w-[300px] xl:text-[24px]">
          {t('scanQR')}
        </p>
        <div className="w-[180px] pb-[20px] lg:w-[250px] xl:w-[300px] xl:pb-0">
          {qrCodeLink && <QRCode size={190} value={qrCodeLink} />}
        </div>
      </div>
    </>
  )
}

export default QRGenerator
